// API Configuration
export const API_CONFIG = {
  BASE_URL: "https://mcp-dev.mecki.ai",
  ENDPOINTS: {
    BRANDING: "/patient/branding",
    VERIFY_DOB: "/patient/verify-dob",
    CONSENT_STATUS: "/patient/consent-status",
    INTAKE_FORM: "/patient/intake-form",
    HIPAA_FORM: "/patient/hipaa-form",
  },
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string, token?: string): string => {
  const baseUrl = API_CONFIG.BASE_URL;
  const fullEndpoint = `${baseUrl}${endpoint}`;
  return token ? `${fullEndpoint}/${token}` : fullEndpoint;
};
